module KendoWidgets
{
	export class ChartOptions implements kendo.dataviz.ui.ChartOptions
	{

	}

	export class Chart extends kendo.dataviz.ui.Chart implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.Chart; }

		constructor(element: Element, options?: KendoWidgets.ChartOptions)
		{
			if (options == null)
				options = new KendoWidgets.ChartOptions();



			super(element, options);
		}

		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.show();
				else
					this.element.hide();
			}

			return this.element.is(":visible");
		}
	}

	Chart.fn = Chart.prototype;
	Chart.fn.options = $.extend(true, {}, kendo.dataviz.ui.Chart.fn.options);
	Chart.fn.options.name = "Chart";
	kendo.ui.plugin(Chart);
}

interface JQuery
{
	kendoChart(options?: KendoWidgets.ChartOptions): JQuery;
}